import { ValidationRule } from "../../error/validationRules";

export const signupFieldValidations: Record<string, ValidationRule[]> = {
  firstName: [ "isRequired" ],
  lastName: [ "isRequired" ],
  email: [ "isRequired", "isEmail" ],
  marketingConsent: [ "isRequired", "isBoolean" ],
  "shippingAddress.postcode": [ "isRequired", "isValidUKPostcode" ],
  "shippingAddress.address1": [ "isRequired" ],
  "shippingAddress.address2": [ ],
  "shippingAddress.city": [ "isRequired" ],
  "shippingAddress.phoneNumber": [ "isRequired", "isValidUKPhoneNumber" ],
  "shippingAddress.province": [ "isRequired" ],
  "billingAddress.postcode": [ "isRequired", "isValidUKPostcode" ],
  "billingAddress.address1": [ "isRequired" ],
  "billingAddress.address2": [ ],
  "billingAddress.city": [ "isRequired" ],
  "billingAddress.countryCode": [ "isRequired" ],
  "billingAddress.phoneNumber": [ "isRequired", "isValidUKPhoneNumber" ],
  deliveryDate: [ "isRequired" ],

  // Wildcard fallback for all cat fields
  "cat.*.name": [ "isRequired" ],
  "cat.*.gender": [ "isRequired" ],
  "cat.*.breed": [ "isRequired" ],
  "cat.*.lifeStage": [ "isRequired" ],
  "cat.*.age.years": [ "isRequired", "isNumber", { type: "isBetween", min: 1, max: 30 } ],
  "cat.*.age.months": [ "isRequired", "isNumber", { type: "isBetween", min: 2, max: 11 } ],
  "cat.*.age.weeks": [ "isRequired", "isNumber", { type: "isBetween", min: 8, max: 51 } ],
  "cat.*.age.mode": [ "isRequired" ],
  "cat.*.birthdayMonth": [ "isRequired" ],
  "cat.*.birthday": [ "isRequired" ],
  "cat.*.isNeutered": [ "isRequired" ],
  "cat.*.body.bodyType": [ "isRequired" ],
  "cat.*.body.activityLevel": [ "isRequired" ],
  "cat.*.weight.valueInKg": [ "isRequired", "isNumber", { type: "isBetween", min: 0.1, max: 20 } ],
  "cat.*.weight.valueInLb": [ "isRequired", "isNumber", { type: "isBetween", min: 0.1, max: 44 } ],
  "cat.*.weight.unit": [ "isRequired" ],
  "cat.*.diet.eatingHabits": [ "isRequired" ],
  "cat.*.diet.current.type": [ "isRequired", "isNotEmptyArray" ],
  "cat.*.diet.current.brand": [ "isRequired" ],
  "cat.*.diet.motivationsForSwitch": [ "isRequired" ],
  "cat.*.diet.healthConcernsToAddress": [ "isRequired", "isNotEmptyArray" ],
  "cat.*.medical.hasConditions": [ "isRequired" ],
  "cat.*.medical.conditions": [ "isRequired", "isNotEmptyArray" ],
  "cat.*.diet.foodAllergies.hasAllergies": [ "isRequired" ],
  "cat.*.diet.foodAllergies.allergens": [ "isRequired", "isNotEmptyArray" ],
};
